<template>
  <v-container
    fluid
    class="px-0 background-green-light py-0 banner-publicidad mb-lg-16"
  >
    <v-container class="px-lg-0 px-10 py-lg-0">
      <v-row class="ma-0 pt-5 py-lg-10">
        <v-col cols="12" lg="6">
          <h3
            class="text-lg-h3 text-h5 text-white font-weight-bold"
            v-html="$t(title)"
          ></h3>
          <p
            class="text-white font-weight-light mt-lg-5"
            v-html="$t(message)"
          ></p>
        </v-col>
      
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    message: {
      required: true,
      type: String,
    },
  },
};
</script>